module.exports = __webpack_public_path__ + "cbf4339e858edf2b14d20140b2887343.woff";